import React from 'react';

function PlanningBalanceCard({ materialList, existingPlans, invoiceSummary = [] }) {
  if (!Array.isArray(materialList) || materialList.length === 0) return null;

  const planMap = {};
  const invoiceMap = {};

  for (const plan of existingPlans || []) {
    const mid = plan.material_id;
    const qty = parseFloat(plan.planned_qty || 0);
    if (!planMap[mid]) planMap[mid] = 0;
    planMap[mid] += qty;
  }

  for (const row of invoiceSummary || []) {
    const mid = row.material_id;
    const qty = parseFloat(row.invoiced_qty || 0);
    if (!invoiceMap[mid]) invoiceMap[mid] = 0;
    invoiceMap[mid] += qty;
  }

  const balanceData = materialList.map(material => {
    const soQty = parseFloat(material.qty || 0);
    const plannedQty = planMap[material.id] || 0;
    const invoicedQty = invoiceMap[material.id] || 0;

    const soMinusPlanned = soQty - plannedQty;
    const soMinusInvoiced = soQty - invoicedQty;

    return {
      material_id: material.id,
      material_name: material.material_name,
      so_qty: soQty,
      planned_qty: plannedQty,
      invoiced_qty: invoicedQty,
      balance_planned: soMinusPlanned,
      balance_invoiced: soMinusInvoiced
    };
  });

  const total = {
    so_qty: 0,
    planned_qty: 0,
    invoiced_qty: 0,
    balance_planned: 0,
    balance_invoiced: 0
  };

  balanceData.forEach(row => {
    total.so_qty += row.so_qty;
    total.planned_qty += row.planned_qty;
    total.invoiced_qty += row.invoiced_qty;
    total.balance_planned += row.balance_planned;
    total.balance_invoiced += row.balance_invoiced;
  });

  return (
    <div className="card border-info rounded-4 shadow-sm mt-4">
      <div className="card-body p-3">
        <h6 className="text-info fw-bold mb-3">Balance Quantity Overview</h6>
        <div className="table-responsive">
          <table className="table table-bordered table-sm table-striped">
            <thead className="table-info text-center">
              <tr>
                <th>#</th>
                <th>Material</th>
                <th>Sales Order Qty</th>
                <th>Planned Qty</th>
                <th>Invoiced Qty</th>
                <th>Balance (SO - Planned)</th>
                <th>Balance (SO - Invoiced)</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {balanceData.map((row, i) => (
                <tr key={row.material_id}>
                  <td>{i + 1}</td>
                  <td className="text-start">{row.material_name}</td>
                  <td>{row.so_qty.toFixed(3)}</td>
                  <td>{row.planned_qty.toFixed(3)}</td>
                  <td>{row.invoiced_qty.toFixed(3)}</td>
                  <td>{row.balance_planned.toFixed(3)}</td>
                  <td><strong>{row.balance_invoiced.toFixed(3)}</strong></td>
                </tr>
              ))}
              <tr className="fw-bold table-light">
                <td colSpan={2}>Total</td>
                <td>{total.so_qty.toFixed(3)}</td>
                <td>{total.planned_qty.toFixed(3)}</td>
                <td>{total.invoiced_qty.toFixed(3)}</td>
                <td>{total.balance_planned.toFixed(3)}</td>
                <td>{total.balance_invoiced.toFixed(3)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default PlanningBalanceCard;
